// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2qwrc","menu":"header_menu__10HG3"};